window.frMember = {
    id: null,

    publicStorageId:
        "public",


    // ==========================================================
    // INITIALIZE
    // ==========================================================

    init() {
        const memberData =
            document.getElementById(
                "fr-member-data"
            );

        this.id =
            memberData?.dataset.memberId ||
            null;
    },


    // ==========================================================
    // IDENTITY
    // ==========================================================

    isLoggedIn() {
        return Boolean(
            this.id
        );
    },

    getId() {
        return this.id;
    },

    getStorageId() {
        return (
            this.id ||
            this.publicStorageId
        );
    },


    // ==========================================================
    // POST DATA
    // ==========================================================

    getPostData(postId) {
        if (!postId) {
            return {};
        }

        const storageId =
            this.getStorageId();

        const data =
            window.memberDataStore.load(
                storageId
            );

        return (
            data.posts?.[postId] ||
            {}
        );
    },


    // ==========================================================
    // READS
    // ==========================================================

    getReadCount(postId) {
        const postData =
            this.getPostData(
                postId
            );

        return (
            postData.readCount ||
            0
        );
    },

    logRead(postId) {
        if (!postId) {
            return 0;
        }

        const storageId =
            this.getStorageId();

        const data =
            window.memberDataStore.load(
                storageId
            );

        data.posts ||= {};
        data.posts[postId] ||= {};

        const postData =
            data.posts[postId];

        postData.readCount =
            (
                postData.readCount ||
                0
            ) + 1;

        postData.lastReadAt =
            new Date()
                .toISOString();

        window.memberDataStore.save(
            storageId,
            data
        );

        return postData.readCount;
    },


    // ==========================================================
    // FAVORITES
    // ==========================================================

    isFavorite(postId) {
        const postData =
            this.getPostData(
                postId
            );

        return Boolean(
            postData.favorite
        );
    },

    toggleFavorite(
        postId,
        metadata = {}
    ) {
        if (!postId) {
            return false;
        }

        const storageId =
            this.getStorageId();

        const data =
            window.memberDataStore.load(
                storageId
            );

        data.posts ||= {};
        data.posts[postId] ||= {};

        const postData =
            data.posts[postId];

        postData.favorite =
            !Boolean(
                postData.favorite
            );

        /*
         * Favoriting NEVER changes readCount.
         *
         * Reading and favoriting are separate actions.
         * The UI decides whether favoriting is currently
         * permitted.
         */

        if (postData.favorite) {
            postData.title =
                String(
                    metadata.title ||
                    postData.title ||
                    ""
                ).trim();

            postData.book =
                String(
                    metadata.book ||
                    postData.book ||
                    ""
                ).trim();

            postData.url =
                String(
                    metadata.url ||
                    postData.url ||
                    ""
                ).trim();

            postData.pages =
                Math.max(
                    1,
                    Number(
                        metadata.pages ||
                        postData.pages ||
                        1
                    ) || 1
                );

            postData.favoritedAt =
                new Date()
                    .toISOString();
        }

        window.memberDataStore.save(
            storageId,
            data
        );

        return postData.favorite;
    },


    // ==========================================================
    // RESET READER STATE
    //
    // Used by authorized maintenance/testing tools.
    //
    // This clears the persisted member-owned state that can
    // make an item appear Read or Favorite.
    //
    // Mosaic "Seen" state is owned separately by the Books
    // Reader and is cleared there.
    // ==========================================================

    resetReaderState(postId) {
        if (!postId) {
            return false;
        }

        const storageId =
            this.getStorageId();

        const data =
            window.memberDataStore.load(
                storageId
            );

        const postData =
            data.posts?.[postId];

        if (!postData) {
            return true;
        }


        // ------------------------------------------------------
        // READ STATE
        // ------------------------------------------------------

        delete postData.readCount;
        delete postData.lastReadAt;


        // ------------------------------------------------------
        // FAVORITE STATE
        // ------------------------------------------------------

        delete postData.favorite;
        delete postData.favoritedAt;


        /*
         * Favorite display metadata is stored only to support
         * the Favorites collection. Once Favorite is cleared,
         * this cached metadata is no longer needed.
         */

        delete postData.title;
        delete postData.book;
        delete postData.url;
        delete postData.pages;


        // ------------------------------------------------------
        // REMOVE EMPTY POST RECORD
        // ------------------------------------------------------

        if (
            Object.keys(
                postData
            ).length === 0
        ) {
            delete data.posts[
                postId
                ];
        }


        window.memberDataStore.save(
            storageId,
            data
        );

        return true;
    },


    // ==========================================================
    // COLLECTION
    // ==========================================================

    getFavorites() {
        const storageId =
            this.getStorageId();

        const data =
            window.memberDataStore.load(
                storageId
            );

        return Object.entries(
            data.posts ||
            {}
        )
            .filter(
                ([, postData]) =>
                    Boolean(
                        postData.favorite
                    )
            )
            .map(
                ([postId, postData]) => ({
                    postId,
                    ...postData
                })
            );
    }
};

window.frMember.init();